import { createSlice } from '@reduxjs/toolkit';

const csrfSlice = createSlice({
    name: 'csrf',
    initialState: {
        sLoading: false,
        message: '',
    },
    reducers: {
        csrfFailed: (state) => {
            return {
                ...state,
                isLoading: false,
                message: 'CSRF Verification Failed',
            };
        },
    },
});

export { csrfSlice };
